<template>
  <div class="outline" v-for="item in guideItem" :key="item.guID">
    <ul>
      <li>
        <RouterLink
          target="_blank"
          :to="`/guide/detail?guID=${item.guID}&clID=${item.clID}`"
          >{{ item.guName }}</RouterLink
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    guideItem: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.outline {
  background: #fff;
  ul {
    & :hover {
      color: @shColor;
    }
    li {
      height: 50px;
      font-size: 15px;
      line-height: 50px;
      padding-left: 50px;
      border-bottom: 1px solid #dedede;
      width: 830px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
